import Vue from 'vue';
import Router from 'vue-router';
import Editor from 'components/Editor';
import TemplateList from 'pages/TemplateList';
import GroupList from 'pages/GroupList';
import AnalysisList from 'pages/AnalysisList';

import UsersList from 'pages/user/UsersList';
import CustomersList from 'pages/user/CustomersList';
import CompaniesList from 'pages/user/CompaniesList';
// import RolesList from 'pages/user/RolesList'

import MaterialList from 'pages/MaterialList';
import MyTemplate from 'pages/myTemplate/';
// import EditRole from 'pages/EditRole'
import Login from 'pages/Login';
import Layout from 'components/Layout';

import Home from 'pages/home';
import Admin from 'pages/Admin';
import VideoList from 'pages/video/VideoList';
import VideoTemplateList from 'pages/video/VideoTemplateList';
import VideoEdit from 'pages/video/VideoEdit';
import AEVideoEdit from 'pages/video/AEVideoEdit';

import ElementList from 'pages/element/index';
import TagsList from 'pages/tags/List';

import Help from 'pages/help/Index';
import HelpTemplateList from 'pages/help/TemplateList';
import HelpTemplatePrivate from 'pages/help/TemplatePrivate';
import HelpVideoList from 'pages/help/VideoList';
import HelpVideoTemplate from 'pages/help/VideoTemplate';

import DesignTemplateList from 'pages/design/DesignTemplateList';
import DesignVideoList from 'pages/design/DesignVideoList';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            // redirect: '/template/list'
            component: Home
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '',
            component: Admin,
            children: [
                {
                    path: '/template',
                    component: Layout,
                    children: [
                        {
                            path: '',
                            redirect: '/template/list'
                        },
                        {
                            path: 'list',
                            meta: {
                                type: '图片',
                                title: '模板中心',
                                subtitle: '图片模板',
                                showAside: 'template'
                            },
                            component: TemplateList
                        },
                        // {
                        // 	path: 'group',
                        // 	meta: {
                        // 		title: '模板组列表'
                        // 	},
                        // 	component: GroupList
                        // },
                        {
                            path: 'analysis',
                            meta: {
                                title: '数据报表',
                                subtitle: '模板点击率排行'
                            },
                            component: AnalysisList
                        }
                    ]
                },
                {
                    path: '/video',
                    component: Layout,
                    children: [
                        {
                            path: '',
                            redirect: '/video/list'
                        },
                        {
                            path: 'template',
                            meta: {
                                type: '视频',
                                title: '模板中心',
                                subtitle: '视频模板',
                                showAside: 'template'
                            },
                            component: VideoTemplateList
                        }
                    ]
                },
                {
                    path: '/material',
                    component: Layout,
                    children: [
                        {
                            path: '',
                            redirect: '/material/list'
                        },
                        {
                            path: 'list',
                            meta: {
                                title: '素材优选'
                            },
                            component: MaterialList
                        }
                    ]
                },
                {
                    path: '/users',
                    component: Layout,
                    children: [
                        {
                            path: '',
                            redirect: '/users/list'
                        },
                        {
                            path: 'list',
                            meta: {
                                type: '权限管理',
                                title: '后台设置',
                                subtitle: '员工账号',
                                showAside: 'settings'
                            },
                            component: UsersList
                        },
                        {
                            path: '/customers/list',
                            meta: {
                                type: '权限管理',
                                title: '后台设置',
                                subtitle: '客户账号',
                                showAside: 'settings'
                            },
                            component: CustomersList
                        },
                        {
                            path: '/companies/list',
                            meta: {
                                type: '权限管理',
                                title: '后台设置',
                                subtitle: '客户管理',
                                showAside: 'settings'
                            },
                            component: CompaniesList
                        },
                        {
                            path: '/element/list',
                            title: '元素管理',
                            meta: {
                                type: '元素管理',
                                title: '后台设置',
                                subtitle: '元素管理',
                                showAside: 'settings'
                            },
                            component: ElementList
                        },
                        {
                            path: '/tags/list',
                            title: '标签管理',
                            meta: {
                                title: '后台设置',
                                subtitle: '标签管理'
                            },
                            component: TagsList
                        }
                    ]
                },
                // {
                // 	path: '/roles',
                // 	component: Layout,
                // 	children: [
                // 		{
                // 			path: '',
                // 			redirect: '/roles/list'
                // 		},
                // 		{
                // 			path: 'list',
                // 			meta: {
                // 				title: '角色列表'
                // 			},
                // 			component: RolesList
                // 		},
                // 		{
                // 			path: 'edit/:id',
                // 			meta: {
                // 				title: '编辑角色'
                // 			},
                // 			component: EditRole
                // 		},
                // 		{
                // 			path: 'new',
                // 			meta: {
                // 				title: '新建角色'
                // 			},
                // 			component: EditRole
                // 		}
                // 	]
                // },
                {
                    path: '/design',
                    component: Layout,
                    children: [
                        {
                            path: '',
                            redirect: '/design/private/image'
                        },
                        {
                            path: 'private/image',
                            meta: {
                                title: '我的设计',
                                type: '我的创意库',
                                subtitle: '图片',
                                showAside: 'design'
                            },
                            component: DesignTemplateList
                        },
                        {
                            path: 'private/video',
                            meta: {
                                title: '我的设计',
                                type: '我的创意库',
                                subtitle: '视频',
                                showAside: 'design'
                            },
                            component: DesignVideoList
                        },
                        {
                            path: 'template/image',
                            meta: {
                                title: '我的设计',
                                type: '我的模板库',
                                subtitle: '图片',
                                showAside: 'design'
                            },
                            component: MyTemplate
                        },
                        {
                            path: 'template/video',
                            meta: {
                                title: '我的设计',
                                type: '我的模板库',
                                subtitle: '视频',
                                showAside: 'design'
                            },
                            component: VideoList
                        },
                    ]   
                },
                {
                    path: '/works/create',
                    name: 'editor',
                    component: Editor
                },
                {
                    path: '/video/create',
                    meta: {
                        title: '创建视频'
                    },
                    component: VideoEdit
                },
                {
                    path: '/video/edit/:id',
                    meta: {
                        title: '编辑视频'
                    },
                    component: VideoEdit
                },
                {
                    path: '/works/site/:id',
                    name: 'editor',
                    component: Editor
                },
                {
                    path: '/ae/create',
                    meta: {
                        title: '创建AE视频'
                    },
                    component: AEVideoEdit
                },
                {
                    path: '/ae/edit/:id',
                    meta: {
                        title: '编辑AE视频'
                    },
                    component: AEVideoEdit
                },
                {
                    path: '/help',
                    meta: {
                        title: '帮助文档'
                    },
                    component: Help,

                    children: [
                        {
                            path: 'templateList',
                            meta: {
                                title: '如何制作图片模板'
                            },
                            component: HelpTemplateList
                        },
                        {
                            path: 'templatePrivate',
                            meta: {
                                title: '如何应用图片模板'
                            },
                            component: HelpTemplatePrivate
                        },
                        {
                            path: 'videoList',
                            meta: {
                                title: '如何制作视频模板'
                            },
                            component: HelpVideoList
                        },
                        {
                            path: 'videoTemplate',
                            meta: {
                                title: '如何应用视频模板'
                            },
                            component: HelpVideoTemplate
                        }
                    ]
                }
            ]
        },
    ]
});
